import { render, staticRenderFns } from "./c-group-table.vue?vue&type=template&id=2bfe67b8"
import script from "./c-group-table.vue?vue&type=script&lang=js"
export * from "./c-group-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfe67b8')) {
      api.createRecord('2bfe67b8', component.options)
    } else {
      api.reload('2bfe67b8', component.options)
    }
    module.hot.accept("./c-group-table.vue?vue&type=template&id=2bfe67b8", function () {
      api.rerender('2bfe67b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mconfigs/views/branch/c-group-table.vue"
export default component.exports